import {
    AbstractControl,
    ValidatorFn,
    UntypedFormGroup,
    ValidationErrors,
} from '@angular/forms';

/** Confirmation password must be the same as password */
export const confirmationPasswordValidator: ValidatorFn = (
    control: UntypedFormGroup,
): ValidationErrors | null => {
    const password = control.get('Password');
    const confirmation = control.get('ConfirmPassword');

    return !password || !confirmation || password.value !== confirmation.value
        ? { isPasswordDifferent: true }
        : null;
};
